module.exports = __webpack_public_path__ + "media/img/frontend_application/christmas/bg-top-f056dfb865ec8f181f22bef06f4f95fb.png";